import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async'; // ✅ SEO Import
import '../Styles/AboutPage.css';
import Arun_profile_img from '../images/Arun_profile_img.jpg';
import vijaya from '../images/hometeamphotos/vijaya.jpg';
import shambhavi from '../images/hometeamphotos/shambhavi.jpg';
import padma from '../images/hometeamphotos/padma.jpg';  

// --- Custom Hook ---
const useIntersectionObserver = (options) => {
  const [entry, setEntry] = React.useState(null);
  const [node, setNode] = React.useState(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setEntry(entry);
      }
    }, options);

    if (node) observer.observe(node);

    return () => observer.disconnect();
  }, [node, options]);

  return [setNode, entry];
};

// --- Animation Wrapper ---
const AnimateOnScroll = ({ children, animationClass }) => {
  const [ref, entry] = useIntersectionObserver({ threshold: 0.1 });

  return (
    <div
      ref={ref}
      className={`animate-on-scroll ${entry?.isIntersecting ? animationClass : ''}`}
    >
      {children}
    </div>
  );
};

// --- Main Component ---
const AboutPage = () => {
  return (
    <HelmetProvider>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>About Groomwell Salon Hafeezpet | Expert Stylists & Team</title>
        <meta
          name="description"
          content="Learn about Groomwell Salon Hafeezpet, led by Uppala Arun Kumar with 18+ years of experience. Meet our talented team of hair stylists, makeup artists, and beauticians."
        />
        <meta
          name="keywords"
          content="about Groomwell Salon, best salon Hafeezpet team, Groomwell stylists Hyderabad, women salon experts Hafeezpet, bridal makeup artists Hafeezpet"
        />
        <meta name="author" content="Groomwell Salon Hafeezpet" />

        {/* ✅ Open Graph (Social Sharing Preview) */}
        <meta property="og:title" content="About Groomwell Salon Hafeezpet - Meet Our Expert Team" />
        <meta
          property="og:description"
          content="Discover Groomwell Salon Hafeezpet, founded by Arun Kumar with 18 years of expertise. Meet our professional hair stylists & beauticians."
        />
        <meta
          property="og:image"
          content="https://groomwellsalon.in/GROOMWELLTEAM" 
        /> {/* 🔗 Replace with actual team photo URL */}
        <meta property="og:url" content="https://groomwellsalon.in/about" />
        <meta property="og:type" content="website" />

        {/* ✅ Instagram Link */}
        <link rel="me" href="https://www.instagram.com/groomwellsalon/" />
      </Helmet>

      <div className="about-page">
        <section className="owner-section">
          <AnimateOnScroll animationClass="slide-in-left">
            <img
              src={Arun_profile_img}
              alt="Salon Owner Uppala Arun Kumar"
              className="owner-image"
            />
          </AnimateOnScroll>

          <AnimateOnScroll animationClass="slide-in-right">
            <div className="owner-bio">
              <h2>A Word From Our Founder</h2>
              <p>
                A seasoned hair expert with 18 years of experience, he specializes in precision cuts,
                creative styles, and delivering exceptional care tailored to each client.
              </p>
              <p>
                Our team is the heart of our salon, a curated group of talented professionals who
                share my commitment to excellence and continuous learning. We believe that every
                treatment should be a personalized experience, tailored to your unique needs and
                desires. Thank you for trusting us with your beauty journey.
              </p>
              <span className="owner-signature">- Uppala Arun Kumar</span>
            </div>
          </AnimateOnScroll>
        </section>

        <section className="team-section">
          <AnimateOnScroll animationClass="float-up">
            <h2 className="team-title">Meet Our Talented Team</h2>
          </AnimateOnScroll>

          <div className="team-grid">
            {/* Employee 1 */}
            <AnimateOnScroll animationClass="pop-up">
              <div className="employee-card">
                <img src={shambhavi} alt="M Shambhavi - Manager & Makeup Artist" />
                <h3>M Shambhavi</h3>
                <p>Manager & Makeup Artist</p>
              </div>
            </AnimateOnScroll>

            {/* Employee 2 */}
            <AnimateOnScroll animationClass="pop-up">
              <div className="employee-card" style={{ animationDelay: '200ms' }}>
                <img src={padma} alt="Padma - Hair Dresser & Beautician" />
                <h3>Padma</h3>
                <p>Hair Dresser & Beautician</p>
              </div>
            </AnimateOnScroll>

            {/* Employee 3 */}
            <AnimateOnScroll animationClass="pop-up">
              <div className="employee-card" style={{ animationDelay: '600ms' }}>
                <img src={vijaya} alt="Vijaya - Hair Dresser & Beautician" />
                <h3>Vijaya</h3>
                <p>Hair Dresser & Beautician</p>
              </div>
            </AnimateOnScroll>
          </div>
        </section>
      </div>
    </HelmetProvider>
  );
};

export default AboutPage;
